import {RoadKill} from "../RoadKill";
import {DisplayObject} from "pixi.js";
import {Life} from "../component/Life";
import {ISpecialSymData} from "../server/RoadKillData";
import {JumpingWild} from "../component/JumpingWild";
import {Split} from "../component/Split";
import {RoadKillGameConfig} from "../RoadKillGameConfig";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {TopAnimalHead} from "../component/TopAnimalHead";

export class TestCaseUtils {
    private static shouldRun: boolean = false;

    private static checkIndividualAnimalMulti(): void {
        if (RoadKill.model.mode === RoadKillGameMode.RESPIN || RoadKill.model.mode === RoadKillGameMode.FREESPIN) {
            const individualAnimals: TopAnimalHead[] = RoadKill.topAnimalController.individualAnimalsArray;
            RoadKill.model.gameData.specialSymbolList.forEach((individualAnimalData: ISpecialSymData): void => {
                const symName: string = individualAnimalData.symName;
                if (symName === "SW1" && individualAnimals[0].animalHeadCount?.value !== individualAnimalData.getHitCount) {
                    console.warn("Top animal head multiplier does not match with server " + symName);
                    debugger
                }
                if (symName === "SW2" && individualAnimals[1].animalHeadCount?.value !== individualAnimalData.getHitCount) {
                    console.warn("Top animal head multiplier does not match with server ", +symName);
                    debugger
                }
                if (symName === "SW3" && individualAnimals[2].animalHeadCount?.value !== individualAnimalData.getHitCount) {
                    console.warn("Top animal head multiplier does not match with server " + symName);
                    debugger
                }
            })
        }
    }

    private static checkGeneralMultiplier(): void {
        const showedMultiplier: number = RoadKill.backgroundElements.getMultiplierValue();
        if (showedMultiplier !== RoadKill.model.data.persistentMultiplier) {
            if (RoadKill.model.data.mode === RoadKillGameMode.NORMAL && RoadKill.model.data.nextMode === RoadKillGameMode.SUPER_FREESPIN) {
                //console.warn("Invalid no. of Heart due to mode change check it after intro ");
            } else {
                console.warn("Invalid General multiplier :: Actual is : ", RoadKill.model.data.persistentMultiplier, " showed value is ", showedMultiplier);
                debugger
            }
        }
    }

    private static checkHeart(): void {
        const showedHeartCount: number = RoadKill.lifeView.getCount();
        if (showedHeartCount !== RoadKill.model.data.heartList.length) {
            if (RoadKill.model.data.mode === RoadKillGameMode.FREESPIN && RoadKill.model.data.nextMode === RoadKillGameMode.SUPER_FREESPIN) {
                //console.warn("Invalid no. of Heart due to mode change check it after intro ");
            } else {
                console.warn("Invalid no. of Heart :: Actual is : ", RoadKill.model.data.heartList, " showed value is ", showedHeartCount);
                debugger
            }
        }

        RoadKill.lifeView.children.forEach((obj: DisplayObject, index: number) => {
            if ((obj as Life).isGolden != (RoadKill.model.data.heartList[index] == "GOLDEN_HEART")) {
                console.warn("Invalid Heart state :: Actual is : ", RoadKill.model.data.heartList[index], " showed value is ", (obj as Life));
                debugger
            }
        });
    }

    private static checkJumpingWild(): void {
        RoadKill.jumpingWildView.getWilds().forEach((jw: JumpingWild) => {
            const specialSymData: ISpecialSymData | undefined = RoadKill.model.characterData.get(jw.type);
            if (specialSymData) {
                // const finalCoords: number[] = specialSymData.coordToRabbitJump2 || specialSymData.coordToRabbitJump1 || specialSymData.coordTo || specialSymData.coordFrom
                // if (jw.reelPosition.reelId !== finalCoords[0] || jw.reelPosition.rowId !== finalCoords[1]) {
                //     console.warn("Invalid JumpingWild Pos :: Actual is : ", finalCoords, " showed value is ", jw.reelPosition);
                //     debugger
                // }
            } else if (jw.visible) {
                console.warn("Invalid JumpingWild in reel :: Actual is : ", RoadKill.model.characterData.keys(), " showed value is ", jw);
                debugger
            }
        });
    }

    private static checkSymbols(): void {
        for (let reel: number = 0; reel < 5; reel++) {
            for (let row: number = 0; row < 3; row++) {
                if (RoadKillGameConfig.WILD_SYMBOLS.indexOf(RoadKill.model.gameData.evaluatedArea[reel][row]) === -1 && RoadKill.reelView.getVisibleSymbolAt(reel, row).symbolName !== RoadKill.model.gameData.evaluatedArea[reel][row]) {
                    if (RoadKill.model.gameData.evaluatedArea[reel][row] === "W") {
                        const isWild: boolean = RoadKill.reelView.getVisibleSymbolAt(reel, row).hasWild();
                        if (isWild) {
                            continue;
                        }
                    }
                    console.warn("Invalid Symbol :: Actual is : ", RoadKill.model.gameData.evaluatedArea[reel][row], " showed value is ", RoadKill.reelView.getVisibleSymbolAt(reel, row).symbolName, reel, row);
                    debugger
                }
            }
        }
    }

    private static checkSymbolSize(): void {
        const splits: Split[] = RoadKill.jumpingWildView.getSplits();
        for (let reel: number = 0; reel < RoadKill.model.gameData.symbolSizes.length; reel++) {
            for (let row: number = 0; row < RoadKill.model.gameData.symbolSizes[reel].length; row++) {
                if (RoadKill.model.gameData.symbolSizes[reel][row] > 1) {
                    let isSplitFoundInView: boolean = false;
                    const isSplit: boolean = RoadKill.reelView.getVisibleSymbolAt(reel, row).split;
                    if (isSplit) {
                        isSplitFoundInView = true;
                    } else {
                        for (let splitIndex: number = 0; splitIndex < splits.length; splitIndex++) {

                            if ((splits[splitIndex].reelId === reel && splits[splitIndex].rowId === row)) {
                                isSplitFoundInView = true;
                                break;
                            }
                        }
                    }
                    if (RoadKill.model.gameData.evaluatedArea[reel][row] === "SW1" && RoadKill.jumpingWildView.getWilds()[0].upgradedMultiplier?.value === 2) {
                        isSplitFoundInView = true;
                    }

                    if (!isSplitFoundInView) {
                        console.warn("Invalid Symbol Size :: Actual is : ", RoadKill.model.gameData.symbolSizes[reel][row], " showed value is ", RoadKill.reelView.getVisibleSymbolAt(reel, row).symbolName, reel, row);
                        debugger
                    }
                }
            }
        }
    }

    private static checkMassiveWildCombinedAnimalMulti(): void {
        if (RoadKill.model.mode === RoadKillGameMode.SUPER_FREESPIN) {
            if (RoadKill.topAnimalController.getCombinedAnimal()) {
                const combinedAnimalHit: number = RoadKill.topAnimalController.totalHits,
                    totalAnimalHitSFS: number = RoadKill.model.totalAnimalHitsSFS;
                if (combinedAnimalHit !== totalAnimalHitSFS) {
                    console.warn("Combined animal hit count value " + combinedAnimalHit + " is not equal to totalAnimalHitSFS " + totalAnimalHitSFS);
                    debugger
                }
            } else {
                console.warn("Combined animal object is not found!!");
                debugger
            }
        }
    }

    public static test(): void {
        if (this.shouldRun) {
            this.checkGeneralMultiplier();
            this.checkHeart();
            this.checkJumpingWild();
            this.checkSymbols();
            this.checkSymbolSize();
            this.checkMassiveWildCombinedAnimalMulti();
            this.checkIndividualAnimalMulti();
        }
    }
}